import React, { useState } from 'react';
import Wrapper from './Wrapper';
import logo from '../../assets/images/logo-white.svg';

export default function Header() {
    return (
        <header className="bg-primary-green">
            <Wrapper className="flex flex-col-reverse md:flex-row items-start justify-between py-5">
                <a href="https://www.airproducts.co.uk"><img src={logo} alt="The Air Products logo" /></a>

                <p className="w-full text-white text-right mb-8 md:mb-0">
                    <i className="fas fa-phone-alt md:hidden mr-4" aria-hidden="true"></i>
                    <a href="tel:08003890202" className="font-semibold md:font-light hover:underline border-r border-white pr-4 mr-4">UK<span className="hidden md:inline font-semibold">: 0800 389 0202</span></a>
                    <a href="tel:1800995029" className="font-semibold md:font-light hover:underline border-r border-white pr-4 mr-4">IE<span className="hidden md:inline font-semibold">: 1800 995 029</span></a>
                    <a href="mailto:newagent@airproducts.com" className="font-semibold hover:underline">
                        <span className="xs:hidden"><i className="fas fa-envelope mr-1" aria-hidden="true"></i> Email</span>
                        <span className="hidden xs:inline">newagent@airproducts.com</span>
                    </a>
                </p>
            </Wrapper>
        </header>
    );
}